module.exports = {"370322001":"田镇街道","370322002":"芦湖街道","370322101":"青城镇","370322102":"高城镇","370322103":"黑里寨镇","370322104":"唐坊镇","370322105":"常家镇","370322106":"花沟镇","370322108":"木李镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370322.json
// module id = 1276
// module chunks = 0